import React, { Component } from "react";
import { Link, Navigate } from "react-router-dom";
import Table from "../../components/table/Table";
import ActionEditButton from "../../components/UIComponent/ActionTableComponent/ActionEditButton";
import DropdownSelect from "../../components/dropdown/Dropdown";
import SwalServices from "../../services/swalServices/SwalServices";
import MembershipCorporateServices from "../../services/axiosServices/apiServices/MembershipCorporateServices";
import moment from "moment";
import ActionDeleteButton from "../../components/UIComponent/ActionTableComponent/ActionDeleteButton"
import { CommonSuccessMessages } from "../../utils/Messages";
import { SuccessMessage } from "../../utils/Messages";
import { encryptAES } from "../../utils/Encryption";
import { getAuditContext } from "../../utils/audit/AuthenticationLibrary";

export default class MemberManagementModule extends Component {
  constructor(props) {
    super(props);
    this.MembershipCorporateServices = new MembershipCorporateServices();
    this.swalServices = new SwalServices();
    this.state = {
      totalResults: 0,
      isLoading: false,
      redirect: null,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        // SearchByUENNumber: "",
        membershipTypeId: 0,
        statusId: 0,
      },
      membershipType: [],
      membersList: [],
    };
  }

  componentDidMount = () => {
    let audit = getAuditContext();

    this.getAllDropdownsForMemberManagement();
    this.getMembersList();
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

  };

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getMembersList();
  };

  onEditMemberList = (value, index) => {
    let editMembersList = [...this.state.membersList];
    this.setState({
      redirect:
        "/AddEditMemberManagementModule/corporateMemberId?=" +
        encryptAES(editMembersList[index].corporateMemberId),
    });
  };



  onDelete = (value) => {
    const audit = getAuditContext()

    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    }
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "Page"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "Page"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.MembershipCorporateServices.deleteMember(request)
            .then((response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success(
                  SuccessMessage.Delete_Success.replace("{0}", "Page")
                );
                this.getMembersList();
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            });
        }
      });
  };

  actions = (element, index, value) => {
    return element !== "emailTemplateId" ? null : (
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap pointer">
        <div className="flex items-center relative">
          <ActionEditButton
            value={value}
            id={index}
            index={index}
            onActionClick={this.onEditMemberList.bind(this)}
            text="Edit"
          />
          <ActionDeleteButton
            value={value}
            id={index}
            index={index}
            onActionClick={this.onDelete.bind(this)}
            text="Delete"
          />

        </div>
      </td>
    );
  };
  getMembersList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.MembershipCorporateServices.getMembersList(pagination).then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let details = response.responseItem.responseContent;
          let formattedItemList = details.itemList.map((item) => ({
            ...item,
            createdAt: moment(item.createdAt).format("DD-MM-YYYY"),
            linkedMemberCompany:
              item.membershipTypeID === 2 ||
                item.membershipTypeID === 1 ||
                item.membershipTypeID === 4
                ? "-"
                : item.linkedMemberCompany,
          }));

          this.setState({
            membersList: formattedItemList,
            totalResults: response.responseItem.responseContent.totalCount,
          });
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      }
    );
  };
  getAllDropdownsForMemberManagement = () => {
    this.MembershipCorporateServices.getAllDropdownsForMemberManagement().then(
      (response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let membershipType = response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "MembershipType"
          );

          this.setState({
            membershipType: membershipType,
          });
        } else {
          this.swalServices.Error(response.message);
        }
      }
    );
  };
  onDropdown = (e) => {
    const membershipTypeId = e.target.value;

    this.setState(
      (prevState) => ({
        pagination: {
          ...prevState.pagination,
          membershipTypeId,
          pageNo: 1,
        },
      }),
      () => {
        this.getMembersList();
      }
    );
  };
  onSearchChange = (e) => {
    const searchText = e.target.value;

    this.setState(
      (prevState) => ({
        pagination: {
          ...prevState.pagination,
          searchText,
          pageNo: 1,
        },
      }),
      () => {
        this.getMembersList();
      }
    );
  };
  render() {
    if (this.state.redirect != null) {
      return <Navigate to={this.state.redirect} />;
    }
    return (
      <div className="main-body-section">
        <div className="bg-white">
          <div className="grid 2xl:grid-cols-3 lg:grid-cols-2 gap-12 w-full">
            <div className="p-8">
              <div className="col-end-7 col-span-2 grid grid-cols-3 items-center">
                <div className="text-[#757575] text-xl">Search by Company Name:</div>
                <div className="w-80">
                  <input
                    id="default"

                    className="form-input rounded-none w-full shadow-red py-3 text-lg placeholder-[#757575]"
                    type="text"
                    placeholder=""
                    value={this.state.pagination.searchText}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
              <div className="col-end-7 col-span-2 grid grid-cols-3 items-center mt-4">
                <div className="text-[#757575] text-xl">Member Type:</div>
                <div className="w-80">
                  <DropdownSelect
                    drpIdentity="membershipType"
                    optionArray={this.state.membershipType}
                    allowSelectAll={false}
                    setFilterParameters={(selectedValue) =>
                      this.onDropdown({
                        target: {
                          name: "membershipTypeID",
                          value: selectedValue,
                        },
                      })
                    }
                    value={this.state.pagination.membershipTypeId}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-4">
          <Link to="/AddEditMemberManagementModule">
            <button className="btn btn-red text-xl border text-white ">
              <div className="flex items-center">
                <span className="mr-3">
                  <img src="../plus-round-icon.svg" alt="" />
                </span>
                <span className="">Add Member</span>
              </div>
            </button>
          </Link>
        </div>
        <div className="grid grid-cols-6 gap-4 pt-10 px-8">
          <h2 className="col-start-1 col-end-3 text-3xl font-bold text-[#757575]">
            {`Total:${this.state.totalResults}`}
          </h2>
        </div>
        <div className="bottom-list-display">
          <main className="pb-10">
            <div className="w-full mx-auto">
              <div className="relative">
                <div className="email-template-manage-sec">
                  <div className=" mt-6">
                    <Table
                      columns={[
                        { name: "companyName", title: "Company Name" },
                        { name: "companyUen", title: "Company UEN" },
                        {
                          name: "membershipTypeName",
                          title: "Membership Type",
                        },
                        {
                          name: "LinkedMemberCompany",
                          title: "Linked Member Company",
                        },
                        { name: "statusName", title: "Status" },
                        { name: "createdAt", title: "Created Date" },
                        { name: "emailTemplateId", title: "Action" },
                      ]}
                      rows={this.state.membersList}
                      isLoading={this.state.isLoading}
                     // sortingColumns={["", ""]}

                       sortingColumns={[
                         "emailName",
                         "subject",
                         "projectName",
                         "whereUsed",
                       ]}

                      pagination={this.state.pagination}
                      totalResultes={this.state.totalResults}
                      totalCount={this.state.totalResults}
                      setPagination={this.setPagination.bind(this)}
                      customScope={[
                        {
                          column: "emailTemplateId",
                          renderTableData: this.actions.bind(this),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
